module.exports = __webpack_public_path__ + "img/coffee_gift.a3194dd0.svg";